import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import GuidedSearchSingle from "./GuidedSearchSingle";
import CategoryHeaderDescription from "../../../../components/CategoryHeader/CategoryHeaderDescription";
import { normaliseVisualRefinements } from "../GuidedSearch/normaliseVisualRefinements";
import { getLocation } from "../../../../state/modules/router/selectors";
import {
  getGuidedSearchData,
  getSearchTerm,
} from "../../../../state/modules/search";

const normaliseComparableValue = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

export const getResolvedSearchTerm = (searchTerm, location) => {
  const normalisedSearchTerm = normaliseComparableValue(searchTerm);

  if (normalisedSearchTerm) {
    return searchTerm;
  }

  if (typeof location?.query?.q === "string") {
    return location.query.q;
  }

  return new URLSearchParams(location?.search).get("q") || "";
};

export const normaliseBoardGuidedSearchCategories = ({
  contractData,
  searchTerm,
}) => normaliseVisualRefinements(contractData, searchTerm);

export const getGuidedSearchCategories = ({ guidedSearchData, searchTerm }) =>
  normaliseVisualRefinements(guidedSearchData, searchTerm);

const GuidedSearchSingleContainer = ({ withCategoryDescription = false }) => {
  const searchMetadata = useSelector(getGuidedSearchData);
  const searchTermFromStore = useSelector(getSearchTerm);
  const location = useSelector(getLocation);
  const currentPath = location?.pathname;
  const currentSearch = location?.search;

  const guidedSearchCategories = getGuidedSearchCategories({
    guidedSearchData: searchMetadata,
    searchTerm: getResolvedSearchTerm(searchTermFromStore, location),
  });

  if (guidedSearchCategories.length === 0) {
    return null;
  }

  const description = withCategoryDescription ? (
    <div>
      <CategoryHeaderDescription device="mobileOnly" />
      <CategoryHeaderDescription device="desktopOnly" />
    </div>
  ) : undefined;

  return (
    <GuidedSearchSingle
      guidedSearchCategories={guidedSearchCategories}
      currentPath={currentPath}
      currentSearch={currentSearch}
      description={description}
    />
  );
};

GuidedSearchSingleContainer.propTypes = {
  withCategoryDescription: PropTypes.bool,
};

export default GuidedSearchSingleContainer;
